import React from 'react';
import { GoogleMap, withGoogleMap, withScriptjs } from 'react-google-maps';

import { MAPS_URL } from '../../constants/defaultTypes';
const WithcriptMap = withScriptjs(
  withGoogleMap(({ children, ...otherProps }) => {
    return (
      <GoogleMap
        defaultZoom={8}
        defaultCenter={{ lat: -34.397, lng: 88.4045107 }}
        {...otherProps}>
        {children}
      </GoogleMap>
    );
  })
);

const Map = ({ className, children, ...otherProps }) => {
  return (
    <WithcriptMap
      {...otherProps}
      googleMapURL={MAPS_URL}
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div className={className} />}
      mapElement={<div style={{ height: `100%` }} />}>
      {children}
    </WithcriptMap>
  );
};

export default Map;



// WEBPACK FOOTER //
// ./src/Components/Map/index.js